import gql from 'graphql-tag';

const UPDATE_NOTE = gql`
  mutation UpdateNote($id: ID!, $notes: String) {
    update_note(id: $id, notes: $notes) {
      id
      notes
      updated_at
    }
  }
`;

const UPDATE_NOTE_MSB = gql`
  mutation UpdateNote($id: ID!, $notes: String) {
    updateNote(id: $id, notes: $notes) {
      id
      notes
      updated_at
    }
  }
`;

const GET_TRANSLATION_MSB = gql`
  mutation GetTranslation($word: String!, $lesson_id: Int!, $program_id: Int!) {
    translation(word: $word, lesson_id: $lesson_id, program_id: $program_id) {
      original
      regularForm
      translated
      source
      recordExist

      dictionary {
        word
        pronunciation
        inflection
        meaning
        example
      }

      logMsg {
        info
        cacheKey
        data {
          vocabulary_id
          lesson_id
          program_id
          level_id
          rank_id
          word
          translation
          dictionary_data
          language
          type_of_word
          example_sentence
          status
          created_at
          updated_at
        }
      }
    }
  }
`;

export { UPDATE_NOTE, UPDATE_NOTE_MSB, GET_TRANSLATION_MSB };
